import { ChatContextType } from "constants/chat-context-types";
import React, { ReactNode } from "react";
import { CollectionUtils } from "utilities/collection-utils";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

interface ChatContextChipProps {
    context: ChatContextType;
    contextList: ReactNode[];
    onClick?: () => void;
}

const CSS_CLASS_NAME = "c-chat-context-chip";

export const ChatContextChip = (props: ChatContextChipProps) => {
    const { contextList, context, onClick } = props;
    const { useCasiContext } = useFeatureFlags();

    if (!useCasiContext || !context || CollectionUtils.isEmpty(contextList)) {
        return <></>;
    }

    return (
        <div
            className={CSS_CLASS_NAME}
            data-test-id="chat-context-chip"
            onClick={onClick}>
            {contextList.map((entry, index) => (
                <ChatContextEntry
                    key={index}
                    label={entry}
                    showSeparator={index !== contextList.length - 1}
                />
            ))}
        </div>
    );
};

const ChatContextEntry = ({ label, showSeparator }) => {
    return (
        <span className={`${CSS_CLASS_NAME}__entry`}>
            {label}
            {showSeparator ? "  /  " : ""}
        </span>
    );
};
